<template lang="pug">
  .registry.contracts-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="true"
    )
      div(slot="header")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
        .edit-select
          select(@change="changeEditSelect")
            option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs.edit-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'")
            .modal__row
              .modal__col
                accordion(:active="true")
                  template(slot="header")
                    e-form-subtitle(text="Реквизиты")
                  template(slot="body")
                    e-form-group(
                      name="number"
                      inputType="input"
                      label="№ Договора"
                      :model="fields"
                      tabView="tab1"
                      :required="true"
                    )
                    e-form-group(
                      name="dt_start"
                      inputType="calendar"
                      label="От"
                      :model="fields"
                      type="date"
                      tabView="tab1"
                      :required="true"
                    )
                    e-form-group(
                      name="dt_end"
                      inputType="calendar"
                      label="Срок действия"
                      :model="fields"
                      type="date"
                      tabView="tab1"
                      :required="true"
                    )
                    e-form-group(
                      name="status_id"
                      inputType="select"
                      :required="true"
                      label="Статус"
                      :model="fields"
                      tabView="tab1"
                      :options="statuses"
                    )
                accordion(:active="true")
                  template(slot="header")
                    e-form-subtitle(text="Сведения по тко")
                  template(slot="body")
                    e-form-group(
                      name="volume_unit"
                      inputType="select"
                      label="Объём (масса) ТКО по договору (единица измерения)"
                      :model="fields"
                      tabView="tab1"
                      :options="volumes"
                    )

                    e-form-group(
                      name="volume"
                      inputType="input"
                      label="Объём (масса) ТКО по договору"
                      :model="fields"
                      tabView="tab1"
                    )

              .modal__col
                accordion(:active="true")
                  template(slot="header")
                    e-form-subtitle(text="Заказчик")
                  template(slot="body")
                    e-form-group(
                      name="_garbageSourceName"
                      label="Заказчик"
                      :model="fields"
                      :suggestionEndpoint="suggestionEndpointSource"
                      :transformSuggestions="transformSuggestions"
                      @selectItem="selectGarbageSource"
                      placeholder="Начните вводить название..."
                      :suggestDelay="0"
                      :minSuggestLen="2"
                      :useInnerSearch="false"
                      :required="true"
                      tabView="tab1"
                      inputType="suggestion"
                    )
                    e-form-group(
                      name="type"
                      label="Тип Заказчика"
                      :model="fields['garbage_source']"
                      tabView="tab1"
                      :disabled="true"
                    )
                    e-form-group(
                      name="inn"
                      label="ИНН"
                      :model="fields['garbage_source']"
                      tabView="tab1"
                      :disabled="true"
                    )
                    e-form-group(
                      name="legal_address"
                      label="Юридический адрес Заказчика"
                      :model="fields['garbage_source']"
                      tabView="tab1"
                      :disabled="true"
                    )
                    e-form-group(
                      v-if="fields['garbage_source'] && fields['garbage_source'].address"
                      name="address"
                      label="Местоположение Заказчика"
                      :model="fields['garbage_source']"
                      tabView="tab1"
                      :disabled="true"
                    )
                    e-form-group(
                      v-else
                      name="fact_address"
                      label="Местоположение Заказчика"
                      :model="fields['garbage_source']"
                      tabView="tab1"
                      :disabled="true"
                    )


              .modal__col
                accordion(:active="true")
                  template(slot="header")
                    e-form-subtitle(text="Исполнитель")
                  template(slot="body")
                    e-form-group(
                      name="_tkoOperatorName"
                      label="Исполнитель"
                      :model="fields"
                      placeholder="Начните вводить название..."
                      :suggestionEndpoint="suggestionOperatorEndpoint"
                      :transformSuggestions="transformSuggestions"
                      @selectItem="onSelectOperator"
                      :suggestDelay="0"
                      :minSuggestLen="2"
                      :useInnerSearch="false"
                      :required="true"
                      tabView="tab1"
                      inputType="suggestion"
                    )
                    e-form-group(
                      name="inn"
                      inputType="input"
                      label="ИНН"
                      :model="fields['tko_operator']"
                      tabView="tab1"
                      :disabled="true"
                    )
                    e-form-group(
                      name="legal_address"
                      inputType="input"
                      label="Юридический адрес Исполнителя"
                      :model="fields['tko_operator']"
                      tabView="tab1"
                      :disabled="true"
                    )
                    e-form-group(
                      name="fact_address"
                      inputType="input"
                      label="Местоположение Исполнителя"
                      :model="fields['tko_operator']"
                      tabView="tab1"
                      :disabled="true"
                    )

          // Отходообразователи
          .body-flex(v-show="tabView === 'sources'")
            contract-sources(
              :fields="fields"
              @saved="innerUpdated"
              @delete="innerUpdated"
              ref="contractSources"
              v-if="acceptViewSourcesTab"
            )
            div(
              v-else
            ).body.body-table
              p Вкладка источники образования ТКО недоступна для выбранного типа заказчика

          // МЕСТА СБОРА И НАКОПЛЕНИЯ
          .body-flex(v-show="tabView === 'tab3'")
            contract-msns(
              :fields="fields"
              @saved="innerUpdated"
              @delete="innerUpdated"
              ref="contractMsns"
            )

          // ТРАНСПОРТИРОВЩИКИ
          .body-flex(v-show="tabView === 'tab4'")
            contract-transports(
              :fields="fields"
              @saved="innerUpdated"
              @delete="innerUpdated"
              ref="contractTransports"
            )

          // Журнал изменений
          .body-flex(v-show="tabView === 'tab5'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )
          // Документы
          .body-flex(v-show="tabView === 'tab6'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
import { contract, garbage, tko } from '@/api/api-endpoints'
import contractForm from './../mixins/contract-form'
import ContractMsns from './../components/contract-msns'
import ContractTransports from './../components/contract-transports'
import ContractSources from './../components/contract-sources'

export default {
  components: { ContractSources, ContractTransports, ContractMsns },
  mixins: [contractForm],
  computed: {
    moduleId() {
      return this.moduleIds['agreement']
    },
    tabs() {
      let tabs = []
      if (this.acceptViewSourcesTab) {
        tabs = [
          { tab1: 'Общие сведения' },
          { sources: 'Отходообразователи ' },
          { tab3: 'Места сбора и накопления' },
          { tab4: 'Транспортировщики' },
        ]
      } else {
        tabs = [
          { tab1: 'Общие сведения' },
          { tab3: 'Места сбора и накопления' },
          { tab4: 'Транспортировщики' },
        ]
      }
      if (this.fields.id) {
        tabs.push({ tab5: 'Журнал изменений' })
      }
      tabs.push({ tab6: 'Документы' })
      return tabs
    },
  },
  methods: {
    suggestionOperatorEndpoint(ctx, q) {
      return tko.regionalOperators({ query: { q, 'per-page': 50 } })
    },
    suggestionEndpointSource(ctx, q) {
      return garbage.garbages({ query: { q, 'per-page': 50 } })
    },
    getDeleteUrl(id) {
      return contract.contractDelete(id)
    },
    getUpdateOrCreateUrl() {
      return contract.contractUpdateOrCreate(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return contract.contract(route.params.id)
    },
    changeEditSelect(event) {
      const val = this.tabs[event.target.selectedIndex]
      this.tabView = Object.keys(val)[0]
    },
  },
}
</script>
